export function returnThumb(url,size,presentation) {
  let basic = '';

  if(presentation == null) {
    return false;
  }
  if ('basic' in presentation) {  
     basic = presentation.basic
  }
    if(basic != '') { 
        if(basic.content.hasOwnProperty('gallery')){
          if(basic.content.gallery.files.length > 0){
            let images = [];
            basic.content.gallery.files.forEach((slide) => {
              images.push(url + slide.hash + '-' + size + '.jpg');
            });
            return images;
          }else {
            return false;
          }
        }else {
          return false;
        }
      }
}

export function createGoogleMapsLink(selectedPathData,currentCoordinate) {
  let linkStart = "https://www.google.com/maps/dir/?api=1&";
  let origin = "origin=";
  let destination = "destination="
  let waypoints = "waypoints=";
  let travelmode = "travelmode=";
  if(currentCoordinate != 0) {
    origin += currentCoordinate[1] + "," + currentCoordinate[0] + "&";
  } else {
    origin += selectedPathData.pois[0].geometry.coordinates[1] + "," + selectedPathData.pois[0].geometry.coordinates[0] + "&";
  }
  selectedPathData.pois.forEach((poi, index, array) => {
      let coordinates = poi.geometry.coordinates;
      let coordinatesSwitch = coordinates[1] + "," + coordinates[0];
      //origin
       if (array.length - 1 == index) {
          destination += coordinatesSwitch + "&";
      }else {
          waypoints += coordinatesSwitch + "|";
      }
  });
  return linkStart + origin + destination + waypoints;
  //document.querySelector('.maps-nav-link').href = linkStart;
}

export const loadImageAsync = (map, image) => {
  return new Promise((resolve, reject) => {
    console.log("image",image);
    map.loadImage(image, (error, loadedImage) => {
      if (error) reject(error);
      else resolve(loadedImage);
    });
  });
};